import React from "react";
import { Box, Image, IconButton, Text } from "@chakra-ui/react";
import Icon from "@mdi/react";
import { mdiImage, mdiCloseCircle } from "@mdi/js";

/**
 * @callback onPreviewDelete
 * @returns {void}
 */

/**
  * UploadPreviewComponent
  * @name UploadPreviewComponent
  * @param {boolean} isPlaceholder - Returns a placeholder image if true
  * @param {string} img - base64 string of the image we'll show a preview for
  * @param {onPreviewDelete} onDelete
  * @returns JSX.Element
  * @description Used in <CaptureModalComponent /> to preview images we've received from the 'Upload from mobile' flow through a web socket connection
  */
const UploadPreviewComponent = ({ isPlaceholder, img, onDelete }) => {
  return isPlaceholder ? (
    <Box
      data-testid="upload-preview-placeholder"
      display="flex"
      justifyContent="center"
      alignItems="center"
      h="100px"
      borderRadius={6}
      borderStyle="dashed"
      w="100px"
      borderWidth="1px"
      borderColor="tertiaryText"
      p={2}
    >
      <Text color="tertiaryText">
        <Icon path={mdiImage} size={1.5} />
      </Text>
    </Box>
  ) : (
    <Box
      position="relative"
      h="100px"
      w="100px"
      borderRadius={6}
      borderWidth="1px"
      borderColor="tertiaryText"
      p={1}
    >
      <Image data-testid="upload-preview" objectFit="contain" src={img} alt="image" width="100%" height="100%" />
      <IconButton
        variant="ghost"
        data-testid="remove-upload-button"
        aria-label="Remove"
        icon={<Icon path={mdiCloseCircle} size={1} />}
        style={{ position: "absolute", top: "-20px", right: "-20px" }}
        onClick={onDelete}
      />
    </Box>
  );
};

export default UploadPreviewComponent;
